module.exports = __webpack_public_path__ + "img/logoseal.05cd5ee2.png";